import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata} from '../../../../../../utils/builderMetadata'

export type GeneralStylesParams = {
  generalTitleFont: StyleParamType.Font
  generalTitleColor: StyleParamType.Color
  generalSubtitleFont: StyleParamType.Font
  generalSubtitleColor: StyleParamType.Color
  generalSecondaryTitleFont: StyleParamType.Font
  generalSecondaryTitleColor: StyleParamType.Color
  generalBodyFont: StyleParamType.Font
  generalBodyColor: StyleParamType.Color
}

export const generalStylesParams = createStylesParams<GeneralStylesParams>({
  generalTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: params.isMobile ? 28 : 32,
      })(params),
  },
  generalTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  generalSubtitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'p'}),
  },
  generalSubtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  generalSecondaryTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'h2'}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalSecondaryTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalBodyFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalBodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
})
